import { cn } from "@/lib/utils";

export interface HeroPillProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  text: string;
}

const HeroPill: React.FC<HeroPillProps> = ({ text, className, ...props }) => {
  return (
    <span
      className={cn(
        "hero-pill py-[1.2rem] px-[3.2rem] rounded-[7.25rem] text-[#5DF7C8] opacity-85 text-[2rem] font-[400] leading-[3.3rem]",
        className
      )}
      {...props}
    >
      {text}
    </span>
  );
};

HeroPill.displayName = "HeroPill";

export default HeroPill;
